<template>
  <div class="wxLogin">
    <div class="wxLoginQr">
      <img :src="thirdLoginUrl"
           alt />
    </div>
    <div class="wxLoginTips">
      请使用微信扫描二维码关注登录
      <p>“易乐玩”</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      thirdLoginUrl: '',
      wxcheckTimer: null,
      count: 0
    }
  },
  mounted () {
    this.fnWXQRlogin()
  },
  methods: {
    // 微信登录
    fnWXQRlogin () {
      // eslint-disable-next-line
      ELSDK.SDKAPI(
        'wxqr',
        {},
        (res) => {
          if (res.status === 'success') {
            this.thirdLoginUrl = res.data.url
            this.fnCheckWXQRLogin(res.data.sign)
          }
        }
      )
    },
    // 检测微信二维码登录
    fnCheckWXQRLogin (sign) {
      let t = this
      // eslint-disable-next-line
      ELSDK.SDKAPI('wxqrstatus',
        {
          t: sign,
          source_page: 'yilewan_pcbox',
          game_code: t.$cookies.get('jsGameCode') || '',
          attr: t.$cookies.get('jsGameCode') ? 'game' : '',
          attr_value: t.$cookies.get('jsGameCode') ? t.$cookies.get('jsGameCode') : ''
        },
        (r) => {
          if (r.status === 'error') {
            clearTimeout(t.wxcheckTimer)
            t.wxcheckTimer = setTimeout(() => {
              if (t.count * 2 >= 900) {
                clearTimeout(t.wxcheckTimer)
              } else {
                t.fnCheckWXQRLogin(sign)
              }
              t.count++
            }, 2000)
          } else {
            clearTimeout(t.wxcheckTimer)
            this.$emit('fnGetYilewanToken', r.data.isFirst)
          }
        }
      )
    },
  },
  destroyed () {
    clearTimeout(this.wxcheckTimer)
  }
}
</script>
